import { render, staticRenderFns } from "./DashItem.vue?vue&type=template&id=4e1ea85e&scoped=true"
import script from "./DashItem.vue?vue&type=script&lang=js"
export * from "./DashItem.vue?vue&type=script&lang=js"
import style0 from "./DashItem.vue?vue&type=style&index=0&id=4e1ea85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ea85e",
  null
  
)

export default component.exports